import { useEffect } from 'react';

import { NsIcon } from 'components/common/ns-icon/NsIcon';

export const testId = 'stopGapTestId';

export const NsStopgap = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ns-column
      tennis-court="1"
      basketball-court="1"
      hockey-pitch="3"
      data-testid={testId}
    >
      <div>&nbsp;</div>
      <table>
        <tbody>
          <tr>
            <td align="center">
              <br />
              <br />
              <br />
              <NsIcon type="loading" size={4} />
              <br />
              <br />
              <br />
              <br />
            </td>
          </tr>
        </tbody>
      </table>
      <div>&nbsp;</div>
    </ns-column>
  );
};
